var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4147 4.92939C14.1648 4.17924 15.1822 3.75781 16.2431 3.75781C17.304 3.75781 18.3214 4.17924 19.0715 4.92939C20.6336 6.49148 20.6336 9.02414 19.0715 10.5862L16.9502 12.7076C16.5597 13.0981 16.5597 13.7312 16.9502 14.1218C17.3407 14.5123 17.9739 14.5123 18.3644 14.1218L20.4857 12.0005C22.8289 9.65731 22.8289 5.85832 20.4857 3.51517C19.3605 2.38995 17.8344 1.75781 16.2431 1.75781C14.6518 1.75781 13.1257 2.38995 12.0005 3.51517L9.87913 5.63649C9.48861 6.02702 9.48861 6.66018 9.87913 7.05071C10.2697 7.44123 10.9028 7.44123 11.2933 7.05071L13.4147 4.92939Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05071 11.2933C7.44123 10.9028 7.44123 10.2697 7.05071 9.87913C6.66018 9.48861 6.02702 9.48861 5.63649 9.87913L3.51517 12.0005C1.17203 14.3436 1.17203 18.1426 3.51517 20.4857C4.64039 21.611 6.16651 22.2431 7.75781 22.2431C9.34911 22.2431 10.8752 21.611 12.0005 20.4857L14.1218 18.3644C14.5123 17.9739 14.5123 17.3407 14.1218 16.9502C13.7312 16.5597 13.0981 16.5597 12.7076 16.9502L10.5862 19.0715C9.83609 19.8217 8.81868 20.2431 7.75781 20.2431C6.69695 20.2431 5.67953 19.8217 4.92939 19.0715C3.36729 17.5094 3.36729 14.9768 4.92939 13.4147L7.05071 11.2933Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46498 14.1218C8.07446 14.5123 8.07446 15.1455 8.46498 15.536C8.8555 15.9265 9.48867 15.9265 9.87919 15.536L15.536 9.87914C15.9266 9.48862 15.9266 8.85545 15.536 8.46493C15.1455 8.0744 14.5124 8.0744 14.1218 8.46493L8.46498 14.1218Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/referrals.43f2480236e364e42c2718a9ed416808.svg";
export { ForwardRef as ReactComponent };